import { DrawerPanel } from '@dmc/ui';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import PinDropTemplateForm from './components/form/PinDropTemplateForm';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetGeofencePinDropQuery } from '@casops/store/apis/geofencePinDropApi';
import { useListGeofenceStylesQuery } from '@casops/store/apis/geofenceStylesApi';
import { ModelName } from '@casops/store/api';

export function ManagePinDropTemplate(): ReactElement {
  const { t } = useTranslation();

  const {
    currentData: pinDropSettings,
    isSuccess,
    fulfilledTimeStamp,
  } = useGetGeofencePinDropQuery();

  const { isSuccess: isSuccessStyles, fulfilledTimeStamp: stylesFTS } = useListGeofenceStylesQuery(
    undefined,
    {
      refetchOnMountOrArgChange: 120,
    },
  );

  const isLoaded = isSuccess && isSuccessStyles;
  const renderKey = useRenderKey({ fulfilledTimeStamp, stylesFTS });

  return (
    <DrawerPanel
      isLoaded={isLoaded}
      header={t('Model.Edit.Title', { modelName: ModelName.GeofencePinDrop })}
    >
      <PinDropTemplateForm key={renderKey} settings={pinDropSettings} />
    </DrawerPanel>
  );
}

export default ManagePinDropTemplate;
